import React from "react";
import styled from "styled-components";
import { Container } from "../../components/common/Container";

const DivChatPage = styled.div`
  display: flex;
  transition: all 0.4s ease;
  flex: 1;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const HoverZoom = styled.div`
  text-align: center;
  transition: all 0.5s ease;
  padding: 0 4rem;
  &:hover {
    transition: all 0.5s ease;
    transform: scale(1.5);
  }
`;
export default function ComingSoonPage() {
  return (
    <Container>
      <DivChatPage>
        <HoverZoom>
          <img
            alt="img-coding"
            src={"./coding.png"}
            width={256}
            height={256}
            style={{ padding: "1rem" }}
          />
          <p className="text-h-color">Coming soon...</p>
        </HoverZoom>
      </DivChatPage>
    </Container>
  );
}
